import React from 'react';
import s from './s.modules.less';
import Frame from './frame.png';

const HowItWork = () => {
    return (
        <div className={s.wrap}>
            <img src={Frame} alt="text visits" />
        </div>
    );
};

export default HowItWork;
